module.exports = __webpack_public_path__ + "img/leiterinnen_samanta-sola.dfa92fc9.png";